const API_URL = process.env.REACT_APP_BACKEND_URL;

let isRefreshing = false;
let refreshPromise = null;

const doRefresh = async () => {
    try {
        const response = await fetch(`${API_URL}/api/v1/auth/refresh`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({})
        });

        if (!response.ok) {
            return false;
        }

        const data = await response.json();
        if (data.success) {
            localStorage.setItem('accessToken', data.accessToken);
            return true;
        }
        return false;
    } catch (error) {
        console.error('Token refresh failed:', error);
        return false;
    }
};

/**
 * fetch wrapper — Authorization 헤더 자동 부착 + 401 시 자동 refresh & 재시도
 */
export const authFetch = async (url, options = {}) => {
    const isFormData = options.body instanceof FormData;
    const headers = {
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        ...options.headers,
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
    };

    let response = await fetch(url, { ...options, headers, credentials: 'include' });

    if (response.status === 401) {
        // 동시 요청 중복 refresh 방지
        if (!isRefreshing) {
            isRefreshing = true;
            refreshPromise = doRefresh();
        }

        const refreshed = await refreshPromise;
        isRefreshing = false;
        refreshPromise = null;

        if (refreshed) {
            // 새 토큰으로 재시도
            const retryHeaders = {
                ...headers,
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
            };
            response = await fetch(url, { ...options, headers: retryHeaders, credentials: 'include' });
        } else {
            // refresh 실패 → logout 이벤트 발행
            localStorage.removeItem('accessToken');
            window.dispatchEvent(new Event('auth:logout'));
        }
    }

    return response;
};
